<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
      persistent
    >
      <v-card tile>
        <v-toolbar dark color="indigo">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Sub Routes</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <div>
            <div
              class="routes-container"
              v-for="container in openedSubRouteContainers"
              :key="container"
            >
              <div v-if="container != null">
                <SubRouteContainer
                  :mainDocument="mainDocument"
                  :parentRouteId="container.toString()"
                  :isInitiator="isInitiator"
                  :userAccess="userAccess"
                  :accessFrom="accessFrom"
                  :parentRouteDue="parentRouteDue"
                />
              </div>
              <!-- <v-row v-for="child in sub_routes_list.data" :key="child.id">
                <v-col cols="12">
                  <SecondaryRoutes
                    :routeId="initiator_route"
                    :child="child"
                    :inSubRoutes="true"
                    :subRouteIndex="sub_route_index"
                    :routeType="'subroute'"
                    :modalShift="modalShift ? modalShift + 10 : 10"
                  />
                </v-col>
              </v-row> -->
            </div>
          </div>
        </v-card-text>
        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SubRouteContainer from "./SubRouteContainer";

export default {
  name: "SubRouteDetailsModal",
  props: {
    routeId: String,
    dialog: Boolean,
    modalName: String,
    isInitiator: Boolean,
    userAccess: Number,
    mainDocument: Object,
    accessFrom: String,
    parentRouteDue: String
  },
  components: {
    SubRouteContainer,
  },
  data() {
    return {
      sub_routes_dialog: false,
      sub_routes_list: [],
      fetchStatus: false,
      route_data: [],
      initiator_route: this.$route.params.id,
      sub_route_index: null,
      modal_name: "",
      left: "0px",
      subroute_container_count: [],
    };
  },
  methods: {
    ...mapActions([
      "addSubRouteContainer",
      "closeSubRoute",
      "closeSubRouteDetails",
    ]),
    // show(name) {
    //   this.$modal.show(name, {});
    // },
    // hide() {
    //   this.$modal.hide(this.modal_name);
    //   this.$emit("closeDialog", false);
    // },
    close() {
      this.closeSubRouteDetails();
      this.$emit("closeDialog", false);
    },
    // beforeClose() {
    //   this.closeSubRoute();
    //   this.$emit("closeDialog", true);
    // },
    // openSubRoutes() {},
  },
  computed: {
    ...mapGetters(["openedSubRouteContainers"]),
    computedLeft: function() {
      return this.left;
    },
    style() {
      return `.v-dialog__content { padding-left: ${this.left} }`;
    },
  },
  watch: {
    dialog: function() {
      if (this.dialog) {
        this.addSubRouteContainer({ id: this.routeId });
      } else {
        this.sub_routes_list = [];
      }
    },
  },
};
</script>

<style scoped>
.v-card__text {
  margin: 0;
  padding: 0;
  white-space: nowrap;
}

.routes-container {
  height: 100%;
  width: auto;
  white-space: nowrap;
  margin-top: 30px;
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 0;
  padding-right: 0;
  display: inline-block;
  overflow: auto;
}

.v-dialog__content {
  --left: 0px;
  left: -30%;
  position: fixed;
  right: 150px;
  padding-left: 0px;
}

.shift-modal {
  margin-left: 100px;
  background-color: blue;
}

.v-dialog__content > div {
  padding-left: 200px;
  /* color: blue; */
}

.v-dialog--active {
  margin-left: 300px;
}
</style>
